import * as types from '@/store/mutation-types'
import router from '@/router'
import api from '@/services/api/auth'
import { buildSuccess, handleError } from '@/utils/utils.js'
//import { addMinutes } from 'date-fns'
import { store } from '@/store'

//const MINUTES_TO_CHECK_FOR_TOKEN_REFRESH = 1

const getters = {
  user: state => state.user,
  token: state => state.token,
  isTokenSet: state => state.isTokenSet
}

const actions = {
  //userLogin({ commit, dispatch }, payload) {
  userLogin({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit(types.SHOW_LOADING, true)
      api
        .userLogin(payload)
        .then(response => {
          if (response.status === 200) {
            window.localStorage.setItem(
              'user',
              JSON.stringify(response.data.user)
            )
            window.localStorage.setItem(
              'token',
              JSON.stringify(response.data.token)
            )
            window.localStorage.setItem(
              'tokenExpiration',
              JSON.stringify(response.data.expiration)
            )
            window.localStorage.setItem(
              'refreshToken',
              JSON.stringify(response.data.refreshToken)
            )
            if(window.localStorage.getItem('selectedHotspot') == null){
              store.dispatch('setHotspot', response.data.user.hotspots[0])
            }

            commit(types.SAVE_USER, response.data.user)
            commit(types.SAVE_TOKEN, response.data.token)
            commit(types.EMAIL_VERIFIED, response.data.user.verified)
            //window.$bus.$emit('hsSetted', true)

            buildSuccess(
              null,
              commit,
              resolve,
              router.push({
                name: 'dashboard'
              })
            )
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  },
  refreshToken({ commit }) {
    commit(types.SHOW_TOP_LOADING, true)
    return new Promise((resolve, reject) => {
      api
        .refreshToken({token: JSON.parse(window.localStorage.getItem('refreshToken'))})
        .then(response => {
          if (response.status === 200) {
            window.localStorage.setItem(
              'user',
              JSON.stringify(response.data.user)
            )
            window.localStorage.setItem(
              'token',
              JSON.stringify(response.data.token)
            )
            window.localStorage.setItem(
              'tokenExpiration',
              JSON.stringify(response.data.expiration)
            )
            window.localStorage.setItem(
              'refreshToken',
              JSON.stringify(response.data.refreshToken)
            )
            if(window.localStorage.getItem('selectedHotspot') == null){
              store.dispatch('setHotspot', response.data.user.hotspots[0])
            }

            commit(types.SAVE_USER, response.data.user)
            commit(types.SAVE_TOKEN, response.data.token)
            commit(types.EMAIL_VERIFIED, response.data.user.verified)
            commit(types.SHOW_TOP_LOADING, false)
            resolve()
          }
        })
        .catch(error => {
          actions.userLogout({ commit })
          handleError(error, commit, reject)
        })
    })
  },
  autoLogin({ commit }) {
    const user = JSON.parse(localStorage.getItem('user'))
    commit(types.SAVE_USER, user)
    commit(types.SAVE_TOKEN, JSON.parse(localStorage.getItem('token')))
    commit(types.SET_LOCALE, JSON.parse(localStorage.getItem('locale')))
    commit(types.EMAIL_VERIFIED, user.verified)
  },
  userLogout({ commit }) {
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('tokenExpiration')
    window.localStorage.removeItem('user')
    window.localStorage.removeItem('refreshToken')

    commit(types.LOGOUT)
    router.push({
      name: 'login'
    })
    store.dispatch('unsetHotspot')
  },
  showOpenRoute({ commit }) {
    commit(types.LOGOUT)
  }
}

const mutations = {
  [types.SAVE_TOKEN](state, token) {
    state.token = token
    state.isTokenSet = true
  },
  [types.LOGOUT](state) {
    state.user = null
    state.token = null
    state.isTokenSet = false
  },
  [types.SAVE_USER](state, user) {
    state.user = user
  }
}

const state = {
  user: null,
  token: JSON.parse(!!localStorage.getItem('token')) || null,
  isTokenSet: !!localStorage.getItem('token')
}

export default {
  state,
  getters,
  actions,
  mutations
}
